module.exports = __webpack_public_path__ + "img/blue.cdde8e42.jpg";